<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Mis Justificaciones</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( faltas  , 'faltas')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row>

              <v-col cols="12" md="4" lg="2">
                <v-text-field
                  name="name"
                  label="Fecha"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechaini"
                  type="date"
                >
                </v-text-field>
              </v-col>

            	<v-col cols="12" md="4" lg="2">
                <v-text-field
                  name="name"
                  label="Fecha"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechafin"
                  type="date"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="faltas"
							    class="elevation-0"
							    :search="search"
							    :page.sync="page"
			            @page-count="pageCount = $event"
							    :mobile-breakpoint="100"
			            hide-default-footer
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.entrada="{ item }">
							      <v-chip 
							      	v-if="item.estado"
							      	small
							      	:color="item.estado == 1 ? 'green' : 'red'"
							      	dark
                      @click="editItem(item, 1)"
							      >
                      {{ item.entrada }}
                    </v-chip>
							    </template>

                  <template v-slot:item.fecha_registro="{ item }">
                    {{ item.fecha_registro ? item.fecha_registro.substr(0,10) : '' }}
                  </template>
							   
                  <template v-slot:item.entrada="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      :color="item.estado == 1 ? 'green' : 'red'"
                      dark
                      @click="editItem(item, 1)"
                    >
                      {{ item.entrada }}
                    </v-chip>
                  </template>

                  <template v-slot:item.entrada_comida="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      color="grey"
                      dark
                      @click="editItem(item, 2)"
                    >
                      {{ item.entrada_comida }}
                    </v-chip>
                  </template>

                  <template v-slot:item.salida_comida="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      color="grey"
                      dark
                      @click="editItem(item, 3 )"
                    >
                      {{ item.salida_comida }}
                    </v-chip>
                  </template>

                  <template v-slot:item.salida="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      color="grey"
                      dark
                      @click="editItem(item, 4)"
                    >
                      {{ item.salida }}
                    </v-chip>
                  </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem2(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-chip small color="grey"  dark v-if="item.estatus == 10">No solicitado</v-chip>
                    <v-chip small color="yellow"     v-if="item.estatus == 0 ">Solicitado</v-chip>
                    <v-chip small color="green" dark v-if="item.estatus == 1 ">Aceptado</v-chip>
                    <v-chip small color="black"      v-if="item.estatus == 2 ">Rechazado</v-chip>
                  </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialogEditar"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.iddepartamentos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-col cols="12">
            <label>Selecciona un tipo de registro</label>
            <v-radio-group
              v-model="editedItem.categoria"
              column
              readonly
            >
              <v-radio
                label="Entrada"
                :value="1"
              ></v-radio>
              <v-radio
                label="Entrada comida"
                :value="2"
              ></v-radio>
              <v-radio
                label="Salida comida"
                :value="3"
              ></v-radio>
              <v-radio
                label="Salida"
                :value="4"
              ></v-radio>
            </v-radio-group>
          </v-col>

          <div id="map" style="height: 500px; width: 100%;"></div>
        </v-card-text>


        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            rounded
            small
            @click="close"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItem.iddepartamentos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <label>Selecciona un tipo de registro</label>
              <v-radio-group
                v-model="editedItem.categoria"
                column
              >
                <v-radio
                  label="Entrada"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Entrada comida"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="Salida comida"
                  :value="3"
                ></v-radio>
                <v-radio
                  label="Salida"
                  :value="4"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <div id="map" style="height: 500px; width: 100%;"></div>
        </v-card-text>


        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            tile
            small
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            dense
            tile
            small
            @click="addReloj( )"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEditar2"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text v-if="!editedItem.justificacion">
        	<v-row>
	          <v-col cols="12">
	            <label>Anexa tus evidencias de tu ausencia, retardo y de más.</label>
	            
	            <v-file-input small-chips multiple filled v-model="files" accept="image/png, image/jpeg, image/bmp, video/mp4, video/x-m4v, video/*"
	              placeholder="Selecciona tus imagenes" prepend-icon="mdi-camera" label="Imágenes" @change="cargarFotos()">
	            </v-file-input>
	          </v-col>
        	</v-row>

        	<v-row v-if="vistaPrevias.length">
	          <v-col cols="12" md="3" v-for="(img, i) in vistaPrevias" :key="i">
	            <v-card class="py-4 shadowCard">
	              <v-img v-if="!img.video" :src="img.url" contain aspect-ratio="2"></v-img>
	              <video v-else :src="img.url" contain aspect-ratio="2" style="width: 100%; height: 100%;" class="d-flex"></video>
	              <v-btn  color="error"  small  @click="eliminarFoto(img.url)" top right absolute fab >
	                <v-icon>mdi-delete</v-icon>
	              </v-btn>
	            </v-card>
	          </v-col>
	        </v-row>

					<v-row v-if="editedItem && editedItem.evidencias">
	          <v-col cols="12" md="3" v-for="(img, i) in editedItem.evidencias" :key="i">
	            <v-card class="py-4 shadowCard">
	              <v-img :src="url + img.evidencia" contain aspect-ratio="2"></v-img>
	            </v-card>
	          </v-col>
	        </v-row>

	        <v-row>
	        	<v-col cols="12">
	        		<v-text-field
	        			v-model="motivo"
	        			:rows="3"
	        			auto-grow
	        			dense
	        			filled
	        			label="Agrega un motivo de la falta"
	        		></v-text-field>
	        	</v-col>
	        </v-row>


        </v-card-text>
        <v-card-text v-else>
          <v-row>
            <v-col cols="12">
              <label>Evidencias generadas por el usuario.</label>
            </v-col>
          </v-row>

          <v-row v-if="editedItem && editedItem.justificacion">
            <v-col cols="12" md="3" v-for="(img, i) in editedItem.detalles" :key="i">
              <v-card class="py-4 shadowCard">
                <v-img :src="url + img.foto" contain aspect-ratio="2" @click="ver( url + img.foto )"></v-img>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.motivo"
                :rows="3"
                auto-grow
                readonly
                dense
                filled
                label="Agrega un motivo de la falta"
              ></v-text-field>
            </v-col>
          </v-row>


        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            tile
            small
            @click="dialogEditar2 = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            dense
            tile
            small
            @click="addReloj2( )"
            v-if="vistaPrevias.length"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el departamento?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogImagen" max-width="1000px">
      <v-card>
        <v-card-text>
          <v-img :src="imagen" aspect-ratio="2" contain></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  import { Geolocation } from '@capacitor/geolocation';

  import L from "leaflet";

  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],
    
    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
      	idpuestos:0,
      	puesto:'',
        iddepartamentos:0,
				fecha_creacion:null,
				deleted:null,
        categoria: 0
      },

      defaultItem: {
      	idpuestos:0,
      	puesto:'',
        iddepartamentos:0,
				fecha_creacion:null,
				deleted:null,
        categoria: 0
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      faltas: [],
      headers: [
        { text: 'Usuario'       , value: 'usuario'         },
        { text: 'Fecha'         , value: 'fecha'           },
        { text: 'Motivo'        , value: 'motivo'          },
        { text: 'Acepto'        , value: 'acepto'          },
        { text: 'Estatus'       , value: 'estatus'         },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],
      departamentos:[],

      latitude:'',
      longitude:'',

      dialogEditar: false,
      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      map: null,

      categorias:[ 
        { id: 1, tipo : 'Entrada'},
        { id: 2, tipo : 'Entrada Comida'},
        { id: 3, tipo : 'Salida Comida'},
        { id: 4, tipo : 'Salida'},
      ],

      dialogEditar2: false,

      fotos:[],
      files: [],
      vistaPrevias:[],
      headersReporte:[],
      motivo:'',
      url:'',

      dialogImagen: false,
      imagen: null
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar justificación' : 'Ver justificación'
      },
    },

    watch: {
      dialog (val) {

        if( val ){
          this.getCurrentPosition( )
        }
        val || this.close()

      },

      dialogEditar (val) {

        val || this.close()
      },


      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
    	this.url = this.$http.options.root + 'evidencia-reloj/'
      await this.initialize()
      await this.getDepartamentos( )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.faltas = []

        const payload = {
          fechaini: this.fechaini,
        	fechafin: this.fechafin,
        	id: this.getdatosUsuario.id
        }

        return this.$http.post('mis.justificaciones', payload).then(response=>{
        	this.faltas        = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getDepartamentos () {
      	this.cargar = true
        this.departamentos = []
        return this.$http.get('departamentos.list').then(response=>{
        	this.departamentos = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      ver( imagen ){
        this.imagen = imagen
        this.dialogImagen = true
      },

      editItem (item, categoria ) {
        this.editedIndex = this.faltas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem['categoria']  = categoria
        this.dialogEditar = true
		  },

      editItem2 (item ) {
        this.editedIndex = this.faltas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogEditar2 = true
      },


      async getCurrentPosition ( ){
        try {
          const coordinates = await Geolocation.getCurrentPosition();

          this.editedItem.lat  = coordinates.coords.latitude
          this.editedItem.lng  = coordinates.coords.longitude

        } catch (error) {
          console.error('Error getting location', error);
          return null;
        }
      },


      deleteItem (item) {
        this.editedIndex = this.faltas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      close () {
        this.dialog       = false
        this.dialogEditar = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


      addReloj2  () {

      	let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        formData.append('id_usuario'    , this.getdatosUsuario.id )
        formData.append('fecha_registro', this.editedItem.fecha )
        formData.append('motivo'        , this.motivo )

        this.cargar = true

        // Lo mandapos por el EP
        this.$http.post('justificar.falta.evidencias', formData ).then(response=>{
          this.dialog        = false
          this.dialogEditar  = false
          this.dialogEditar2 = false
          this.vistaPrevias  = []
          this.close()
          this.initialize()
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          var video = false
          const nombreSplit = file.name.split('.')
          const extension = nombreSplit[nombreSplit.length-1]
          if(['mp4', 'mov', 'wmv', 'avi'].includes(extension)){
            video = true
          }
          me.vistaPrevias.push({
            url: reader.result, 
            formData: formData, 
            image_name: file.name,
            video : video,
            file
          })
        };
      },
			
			eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },

			convertFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },

			createFile(file) {
        if (file.size > 10000000) {
          alert("please check file size no over 5 MB.");
          this.dragging = false;
          return;
        }

        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos);
        this.dragging = false;
      },

      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
          // creamos una variable tipo FormData
        	let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
          //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          if(element.size > 26214400){ //26214400 = 25MB
            console.log(element.size)
            this.validarErrorDirecto('El archivo sobrepasa el limite del peso, max 25 MB')
          } else {
            this.getBase64(element, formData)
          }
        })
      },
    },
  }
</script>


<style>
	/* Asegúrate de incluir estilos de Leaflet */
	@import "leaflet/dist/leaflet.css";
</style>